const styles = theme => ({
  root: {
    minWidth: '25rem',
    padding: '0 1em 1em 1em'
  },
  title: {
    marginBottom: '1rem'
  }
});

export default styles;
